import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { IDocumentDetailRootDTO } from 'app/main/pages/documents/dto/document-details.dto';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';

@Component({
  selector: 'app-template-roles-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './template-roles-field.component.html',
  styleUrl: './template-roles-field.component.scss'
})
export class TemplateRolesFieldComponent {
  @Input() field: IField;
  @Input() documentData: IDocumentDetailRootDTO;

  
}
